import { ReactNode } from "react";
import MobileDesignActionSheet from "./MobileDesignActionSheet";

interface MobileUploadActionSheetProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
}

const MobileUploadActionSheet = ({
  isOpen,
  onClose,
  children
}: MobileUploadActionSheetProps) => {
  return (
    <MobileDesignActionSheet isOpen={isOpen} onClose={onClose}>
      {children}
    </MobileDesignActionSheet>
  );
};

export default MobileUploadActionSheet;
